import GuestHomeHeader from "../../components/home-header/home-header";
import Accordion from "react-bootstrap/Accordion";
import "./guest-home.scss";
import videoBg from "../../../assets/media/videos/video-bg3.mp4";
import trowelLogo from "../../../assets/media/icons/Trowel-Logo.png";
import marketIcon from "../../../assets/media/icons/icon-b-1.svg";
import opportunityIcon from "../../../assets/media/icons/icon-b-2.svg";
import stepsIcon from "../../../assets/media/icons/icon-b-3.svg";
import business360 from "../../../assets/media/icons/ui-element-1.png";
import workSmarter from "../../../assets/media/icons/ui-element-2.png";
import aiChat from "../../../assets/media/icons/ui-element-3.png";
import dataProtected from "../../../assets/media/icons/ui-element-4.png";

// const GuestHomePage: React.FC = () => {
//   return (
//     <main className="twl-home">
//       <div className="twl-home__box product">
//         <h3>Product</h3>
//         <div>
//           Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet Lorem ipsum
//           dolor sit amet
//         </div>
//       </div>

//       <div className="twl-home__box tagline">
//         <div className="tagline__left left-card">
//           <span className="small-text">Tagline</span>
//           <div className="sub-headding">
//             Medium length section heading goes here
//           </div>
//           <div className="small-sub-headding">
//             Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet Lorem ipsum
//             dolor sit amet Lorem ipsum dolor sit amet, Lorem ipsum dolor sit
//             amet Lorem ipsum dolor sit amet
//           </div>
//           <div className="split-text-percent">
//             <div className="split-text-percent__left">
//               <span className="--amount-percent">50%</span>
//               <span>
//                 Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet Lorem
//                 ipsum
//               </span>
//             </div>
//             <div className="split-text-percent__right">
//               <span className="--amount-percent">50%</span>
//               <span>
//                 Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet Lorem
//                 ipsum
//               </span>
//             </div>
//           </div>
//         </div>
//         <div className="tagline__right"></div>
//       </div>
//     </main>
//   );
// };

import React, { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const typeStrings = [
  "Best strategy to grow my business faster?",
  "How to find growth opportunities?",
  "How to reach new markets?",
];

const GuestHomePage: React.FC = () => {
  const itypedRef = useRef<HTMLSpanElement>(null);

  const navigate = useNavigate();
  
  useEffect(() => {
    let idx = 0, charIdx = 0, isDeleting = false;
    const el = itypedRef.current;
    let timer: NodeJS.Timeout;
    function type() {
      if (!el) return;
      const current = typeStrings[idx % typeStrings.length];
      el.textContent = current.substring(0, charIdx);
      if (isDeleting) {
        charIdx--;
        if (charIdx < 0) {
          isDeleting = false;
          idx++;
          timer = setTimeout(type, 800);
        } else {
          timer = setTimeout(type, 40);
        }
      } else {
        charIdx++;
        if (charIdx > current.length) {
          isDeleting = true;
          timer = setTimeout(type, 1200);
        } else {
          timer = setTimeout(type, 70);
        }
      }
    }
    type();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="section-main guest-home">
      <div className="banner-container position-relative">
        {/* Navbar */}
        <nav className="navbar navbar-expand-md position-fixed nav-bar-main w-100 tr-header">
          <div className="container-fluid no-pd-mg">
            <a className="navbar-brand no-pd-mg logo-container" href="/">
              <img height={40} src={trowelLogo} alt="Trowel Logo" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navcol-2"
              aria-controls="navcol-2"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="visually-hidden">Toggle navigation</span>
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navcol-2" style={{ height: 56 }}>
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <a className="nav-link" onClick={() => navigate('/about-us')} style={{ cursor: 'pointer' }}>About Us</a>
                </li>
              </ul>
              <div className="nav-right">
                <span onClick={()=>navigate('/login')} className="btn btn-link btn-lg btn-t2">Login</span>
                <span onClick={()=>navigate('/create-account')} className="btn btn-secondary btn-lg btn-t2">Get started</span>
              </div>
            </div>
          </div>
        </nav>
        {/* Banner Heading */}
        <div className="banner-heading text-center">
          <h1>Smarter Insights. Stronger Growth.</h1>
          <h5>
            Your AI business partner that uncovers challenges, delivers solutions, <br />
            and drives sales, marketing, HR, and company growth.
          </h5>
          <div className="chat-container">
            <div className="t-container">
              <h3>
                <span ref={itypedRef}></span>
                <span className="typewriter-cursor" />
              </h3>
            </div>
            <div className="icon-container">
              <svg className="bi bi-send" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"></path>
              </svg>
            </div>
          </div>
          <div className="gap-c"></div>
          <span className="btn btn-link" onClick={()=>navigate('/create-account')}>Get started free</span>
        </div>
        {/* Overlays and Video */}
        <div className="gr-overlay radial-gradient-position2"></div>
        <div className="gr-overlay radial-gradient-position"></div>
        <div className="gr-overlay radial-gradient-position3"></div>
        <div className="gr-overlay radial-gradient-position4"></div>
        <div className="video-container">
          <video width="100%" height="100%" autoPlay loop muted>
            <source src={videoBg} type="video/mp4" />
          </video>
        </div>
      </div>
      {/* Features Section */}
      <section className="section-features">
        <div className="container py-4 py-xl-5">
          <div className="row mb-5">
            <div className="col-md-10 text-center mx-auto">
              <h2>Put your business in context,&nbsp;<br />without the jargon.</h2>
            </div>
          </div>
          <div className="row gy-4 row-cols-1 row-cols-md-3 row-cols-xl-3 just">
            {[
              {
                icon: marketIcon,
                title: "Know your Market",
                text: "We show you what’s happening in your world—your customers, competitors, and trends—so you can stay ahead.",
              },
              {
                icon: opportunityIcon,
                title: "Spot New Opportunities",
                text: "Find out where you can grow, what to try next, and how to stand out",
              },
              {
                icon: stepsIcon,
                title: "Get Clear Next Steps",
                text: "No long reports—just easy actions you can take today.",
              },
            ].map((feature, idx) => (
              <div className="col justify-content-between" key={idx}>
                <div className="card">
                  <div className="card-body text-center p-4">
                    <div className="bs-icon-md justify-content-center align-items-center mb-3 d-inline-block bs-icon">
                      <img src={feature.icon} alt="" />
                    </div>
                    <h4 className="card-title">{feature.title}</h4>
                    <p className="card-text f-sub-head">{feature.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Features Rows */}
      {[
        {
          heading: "360° View of Your Business",
          text: "Understand your strengths, spot weaknesses, uncover opportunities, and stay ahead of threats.",
          img: business360,
          reverse: false,
        },
        {
          heading: "Work Smarter, Not Harder",
          text: "Automate the routine stuff and free up your time for the things that truly move your business forward",
          img: workSmarter,
          reverse: true,
        },
        {
          heading: "Always-On AI Chat",
          text: "Connect anytime with our AI assistant for instant business insights, strategic advice, and real-time support.",
          img: aiChat,
          reverse: false,
        },
        {
          heading: "Your Data, Always Protected",
          text: "We keep your information safe and secure, so you can grow with peace of mind.",
          img: dataProtected,
          reverse: true,
        },
      ].map((row, idx) => (
        <div className="container" key={idx}>
          <div className="row align-items-center fr-row">
            <div className={`col-sm-12 col-md-12 col-lg-6${row.reverse ? " order-xs-2" : ""} content-fr`}>
              <div className="features features1">
                <h3>{row.heading}</h3>
                <p>{row.text}</p>
              </div>
            </div>
            <div className={`col-sm-12 col-md-12 col-lg-6${row.reverse ? " order-xs-1" : ""}`}>
              <div className="ui-container">
                <img className="img-fluid" src={row.img} alt="" />
              </div>
            </div>
          </div>
        </div>
      ))}
      {/* FAQ Section */}
      <div className="container faq-heading">
        <div className="row">
          <div className="col text-center heading-item">
            <h2>Frequently Asked Questions</h2>
            <p>Got questions?<br />Check our FAQ for tips, answers, and quick solutions!</p>
          </div>
        </div>
      </div>
      <div className="container accordion-container">
        <Accordion defaultActiveKey="0" className="faq-accordion">
          {[
            {
              q: "What is Trowel?",
              a: "Trowel is your friendly business growth buddy. We turn complex data into simple, actionable insights you can actually use.",
            },
            {
              q: "Do I need to be “tech-savvy” to use Trowel?",
              a: "Nope! If you can answer a few questions and click a button, you’re good to go.",
            },
            {
              q: "What kind of insights will I get?",
              a: "You’ll see what’s working, what’s holding you back, and clear steps to grow your business and stay competitive.",
            },
            {
              q: "How does Trowel make this fun?",
              a: "We guide you like a game—mini challenges, quick wins, and progress tracking. Growing your business doesn’t have to feel like homework.",
            },
            {
              q: "Will Trowel do the work for me?",
              a: "We won’t run your shop for you 😉, but we’ll give you smart recommendations, help set goals, and even automate repetitive tasks so things feel lighter.",
            },
            {
              q: "Is my data safe?",
              a: "Yes! Your data stays private and secure. We take security seriously so you can use Trowel with peace of mind.",
            },
            {
              q: "How much does it cost to try?",
              a: "You can start for free—no credit card required. Just jump in and explore.",
            },
            {
              q: "Can I see results quickly?",
              a: "Definitely. Once you plug in your info, Trowel immediately crunches the data and shows clear, actionable next steps — often before you finish your first coffee.",
            },
          ].map((faq, idx) => (
            <Accordion.Item eventKey={String(idx)} key={idx}>
              <Accordion.Header>{faq.q}</Accordion.Header>
              <Accordion.Body>
                <p className="mb-0">{faq.a}</p>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
      {/* Footer */}
      <footer className="text-center py-4">
        <div className="container footer-container">
          <div className="row row-cols-1 row-cols-lg-3">
            <div className="col text-start item">
              <img height={28} src={trowelLogo} alt="Trowel Logo" />
            </div>
            <div className="col item">
              <ul className="list-inline my-2">
                <li className="list-inline-item me-4">
                  <a className="bs-icon-circle bs-icon-primary bs-icon" href="#">
                    {/* Facebook SVG */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-facebook">
                      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"></path>
                    </svg>
                  </a>
                </li>
                <li className="list-inline-item me-4">
                  <a className="bs-icon-circle bs-icon-primary bs-icon" href="#">
                    {/* Twitter SVG */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-twitter-x">
                      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z"></path>
                    </svg>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a className="bs-icon-circle bs-icon-primary bs-icon" href="#">
                    {/* Instagram SVG */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" className="bi bi-instagram">
                      <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col text-end item">
              <ul className="list-inline my-2 footer-privacy">
                <li className="list-inline-item"><a className="link-body-emphasis" onClick={() => navigate('/about-us')} style={{ cursor: 'pointer' }}>About Us</a></li>
                <li className="list-inline-item"><a className="link-body-emphasis" href="#">Privacy Policy</a></li>
                <li className="list-inline-item"><a className="link-body-emphasis" href="#">Terms of Use</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GuestHomePage;
